import type { BatchPreviewLinkProps } from "./batch-preview-link.type";

import { ExportOutlined } from "@ant-design/icons";
import { Link } from "react-router";

import ModelIcon from "@/modules/model-icon";
import {
  useOrganizationContext,
  useOrganizationCustomContextNotify,
} from "@/modules/organization/organization-context";

import { buildBatchPreviewLinkSearch } from "./batch-preview-link.helper";

import "./batch-preview-link.style.less";

export const BatchPreviewLink = ({
  customContext,
  params,
  icon,
  onClick,
  children,
}: BatchPreviewLinkProps) => {
  const { contextSlug } = useOrganizationContext();
  const { notifyContextChange } = useOrganizationCustomContextNotify();

  const context = customContext ?? contextSlug;
  const searchParams = buildBatchPreviewLinkSearch(params);
  const to = `/org/${context}/batch-preview${searchParams}`;

  const onLinkClick = () => {
    notifyContextChange(customContext);
    onClick?.();
  };

  return (
    <Link to={to} onClick={onLinkClick} className="batch-preview-link">
      {children}
      {icon === "external" ? (
        <ExportOutlined />
      ) : icon ? (
        <ModelIcon model={icon} />
      ) : null}
    </Link>
  );
};
